module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"textDialog":"Your testing time has expired, and the test results have been transferred to the employer.","close":"Close","left":"Time remaining","timeToComplete":"Time to complete","minutes":"min"}}')
  delete Component.options._Ctor
}
